// extracted by mini-css-extract-plugin
export default {"card":"styles_card__TcKKm","cardImage":"styles_cardImage__WV1KO","text":"styles_text__hwQ52"};